<style scoped>
</style>

<template>
  <div class="section border border-1 border-dark pt-2 pb-2 ps-2">
    <span>
      <button class="btn btn-sm btn-primary" @click="history.panelOpened = !history.panelOpened">
        <i class="fa fa-bars"></i>
      </button>
      <h2 class="ms-2 header">履歴リスト</h2>
      <a class="ms-2 ext-link" target="_blank" href="https://scrapbox.io/mhrise-queque/member-history"><i class="fas fa-question-circle"></i></a>
    </span>
    <CollapseTransition class="mt-2 ps-4">
      <div v-show="history.panelOpened">
        <div>
          <button class="btn btn-sm btn-primary" v-on:click="gotoPrevPage">
            <i class="fas fa-caret-left"></i>
          </button>
          <span class="mx-2 text-center" style="display: inline-block; width: 3em">{{1 + pageIndex}} / {{1 + maxPageIndex}}</span>
          <button class="btn btn-sm btn-primary" v-on:click="gotoNextPage">
            <i class="fas fa-caret-right"></i>
          </button>
        </div>
        <table>
          <tr>
            <th></th>  <!-- xボタン -->
            <th></th>  <!-- 参加待ちに登録ボタン -->
            <th class="text-cell text-center">参加回数<br/>(合計)</th>
            <th class="text-cell text-center">参加回数<br/>(小計)</th>
            <th class="text-cell">名前</th>
            <th class="text-cell">ハンター名</th>
            <th class="text-cell">メモ</th>
          </tr>
          <tr v-for="m in members" :key="m.index">
            <td>
              <button tabindex="-1" class="btn btn-sm btn-danger" v-on:click="onHistoryRemoved(m.index)">
                <i class="fas fa-times"></i>
              </button>
            </td>
            <td>
              <button class="btn btn-sm btn-primary" v-bind:class="{ 'btn-secondary': !hasEmpty }"
                v-on:click="onHistoryToWaiting(m.index)">参加待ちに登録</button>
            </td>
            <td class="text-center">
              {{m.member.grandTotalSortieCount}}
            </td>
            <td class="text-center">
              {{m.member.totalSortieCount}}
            </td>
            <td class="text-cell">
              <span class="name">{{m.member.name}}</span>
            </td>
            <td class="text-cell" style="min-width: 100px;" v-on:click="onBeginEdit(m.index, 'hunterName')">
              <template v-if="m.index == editIndexes.hunterName">
                <input ref="hunterName" type="text" v-model="m.member.hunterName"
                  v-on:keypress.enter.exact="editIndexes.hunterName = -1"
                  v-on:blur="onEndEdit(m.index, 'hunterName')"
                  >
              </template>
              <template v-else>
                <span>{{m.member.hunterName}}</span>
              </template>
            </td>
            <td class="text-cell" style="min-width: 100px;" v-on:click="onBeginEdit(m.index, 'memo')">
              <template v-if="m.index == editIndexes.memo">
                <input ref="memo" type="text" v-model="m.member.memo"
                  v-on:keypress.enter.exact="editIndexes.memo = -1"
                  v-on:blur="onEndEdit(m.index, 'memo')"
                  >
              </template>
              <template v-else>
                <span>{{m.member.memo}}</span>
              </template>
            </td>
          </tr>
        </table>
        <div class="mt-2">
          <button class="btn btn-sm btn-primary" v-on:click="onCopyHistory">履歴をすべてコピー</button>
          <button class="ms-2 btn btn-sm btn-primary" v-on:click="onPasteHistory">履歴を入れ替えペースト</button>
        </div>
      </div>
    </CollapseTransition>
    <!--
    <pre>{{$props}}</pre>
    <pre>{{$data}}</pre>
    -->
  </div>
</template>

<script>
import _ from 'lodash'
import { CollapseTransition } from "@ivanv/vue-collapse-transition"

export default {
  components: {
    CollapseTransition,
  },
  props: {
    config: { type: Object, required: true },
    waiting: { type: Object, required: true },
    history: { type: Object, required: true }
  },
  data() {
    return {
      opened: false,
      pageSize: 10,
      pageIndex: 0,
      editIndexes: {
        hunterName: -1,
        memo: -1,
      },
    }
  },
  computed: {
    hasEmpty() {
      return this.waiting.members.length < this.config.maxWaitingMemberCount
    },
    members() {
      let size = this.pageSize
      return this.history.members
        .slice(size * this.pageIndex, size * (this.pageIndex + 1))
        .map((m, i) => ({index: size * this.pageIndex + i, member: m}))
    },
    maxPageIndex() {
      return Math.max(0, Math.ceil(this.history.members.length / this.pageSize) - 1)
    },
  },
  methods: {
    addHistory(entries) {
      entries.forEach(entry => {
        let i = this.history.members.findIndex(m => m.name == entry.name)
        if (0 <= i) {
          this.moveUpHistoryMember(i, entry)
        }
        else {
          this.history.members.unshift(entry);
        }
      })
      
      this.$emit('change', this.history)
    },
    changeEntries(entries) {
      entries.forEach(entry => {
        this.history.members.filter(m => m.name == entry.name).forEach(m => {
          this.$set(m, 'hunterName', entry.hunterName)
          this.$set(m, 'memo', entry.memo)
          this.$set(m, 'grandTotalSortieCount', entry.grandTotalSortieCount)
          this.$set(m, 'totalSortieCount', entry.totalSortieCount)
        })
      })
    },
    onHistoryRemoved: function(i) {
      this.history.members.splice(i, 1)

      if (this.maxPageIndex < this.pageIndex) {
        this.pageIndex = this.pageIndex - 1
      }

      this.$emit('change', this.history)
    },
    onHistoryToWaiting: function(i) {
      if (this.config.maxWaitingMemberCount <= this.waiting.members.length) return

      let entry = this.history.members[i]
      this.moveUpHistoryMember(i, entry)
      this.$emit('add-to-waiting', [entry])
      this.$emit('change', this.history)
    },
    onBeginEdit(i, fieldName) {
      this.editIndexes[fieldName] = i

      this.$nextTick(() => {
        this.$refs[fieldName][0].focus()
        this.$refs[fieldName][0].setSelectionRange(-1, -1)
      })
    },
    onEndEdit(i, fieldName) {
      this.editIndexes[fieldName] = -1
      this.$emit('change-entries', [this.history.members[i]])
    },
    onCopyHistory: function() {
      let s = this.history.members
        .map(m => {
          return [m.name, m.hunterName, m.memo].join("\t")
        })
        .join("\n")

      navigator.clipboard.writeText(s)

      this.$toasted.success('履歴リストをコピーしました')
    },
    onPasteHistory: function() {
      navigator.clipboard.readText().then(text => {
        let members = text.split(/\n|\r\n/)
          .map(line=> {
            var values = line.split("\t")
            return {
              name: values[0].trim(),
              hunterName: (values[1] ?? '').trim(),
              memo: (values[2] ?? '').trim()
            }
          })
          .filter(m => m.name != '')
        this.history.members = _.uniqWith(members, _.isEqual)
      })

      this.$emit('change', this.history)

      this.$toasted.success('履歴リストをペーストしました')
    },
    gotoPrevPage() {
      if (this.pageIndex <= 0) return

      this.pageIndex = this.pageIndex - 1
    },
    gotoNextPage() {
      if (this.maxPageIndex <= this.pageIndex) return

      this.pageIndex = this.pageIndex + 1
    },
    moveUpHistoryMember(i, entry) {
      let m = this.history.members[i]

      m.hunterName = entry.hunterName
      if (m.memo.indexOf(entry.memo) < 0) {
        m.memo += ` ${entry.memo}`
      }

      this.history.members.splice(i, 1)
      this.history.members.unshift(m)
    },
  }
}
</script>
